export default __webpack_public_path__ + "static/media/iam_l1.b26b7cc9.png";